<!-- Heading -->
<mdb-card class="mb-4 wow fadeIn">

    <!--Card content-->
    <mdb-card-body class="d-sm-flex justify-content-between ">
        <div style="display: contents;">
            <h4 class="mb-sm-0 pt-2 ">
                <span>Market Trades</span>
            </h4>
        </div>
    </mdb-card-body>
</mdb-card>

<div id="reccomendations">
    <div class="col-xl-4 col-md-6 pl-0 d-inline-block">
        <mdb-card class="mb-4 wow fadeIn">
            <mdb-card-body class="d-sm-flex justify-content-between">
                <div class="col-12">
                    <!--Error Display-->
                    <div class="col-12">
                        <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
                            {{errorMsg}}
                        </div>
                    </div>
                    <!--Main Body-->
                    Market Trade Reccommendation 1
                    <!--End Main Body-->
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>
    <div class="col-xl-4 col-md-6 d-inline-block">
        <mdb-card class="mb-4 wow fadeIn">
            <mdb-card-body class="d-sm-flex justify-content-between">
                <div class="col-12">
                    <!--Error Display-->
                    <div class="col-12">
                        <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
                            {{errorMsg}}
                        </div>
                    </div>
                    <!--Main Body-->
                    Market Trade Reccommendation 2
                    <!--End Main Body-->
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>
    <div class="col-xl-4 col-md-6 pr-0 d-inline-block">
        <mdb-card class="mb-4 wow fadeIn">
            <mdb-card-body class="d-sm-flex justify-content-between">
                <div class="col-12">
                    <!--Error Display-->
                    <div class="col-12">
                        <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
                            {{errorMsg}}
                        </div>
                    </div>
                    <!--Main Body-->
                    Market Trade Reccommendation 3
                    <!--End Main Body-->
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>
</div>

<div id="CurrentInvestments">
    <div class="col-xl-12 col-md-12 pr-0 d-inline-block pl-0">
        <mdb-card class="mb-12 wow fadeIn">
            <mdb-card-body class="d-sm-flex justify-content-between">
                <div class="col-12">
                    <!--Error Display-->
                    <div class="col-12">
                        <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
                            {{errorMsg}}
                        </div>
                    </div>
                    <!--Main Body-->
                    <div class="d-block col-12 text-center">
                        <p class="font-weight-bold mb-1">Current Investments</p>
                    </div>
                    <div >
                        <p>Current available amount: </p>
                    </div>
                    <!--End Main Body-->
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>
</div>